import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { BasicConfigurationModel } from '@/modules/settings/types/basic';

/**
 * Handles saving Basic Configuration data via PUT.
 */
export function useMutateBaseSettings(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Partial<BasicConfigurationModel>) => {
      const { data } = await axiosInstance.post<BasicConfigurationModel>(
        `/api/${companyId}/configuration/saveBasicConfiguration`,
        payload
      );
      return data;
    },

    onError: (error) => {
      // @TODO handle error properly
      // show notification to user
      console.error('Error saving basic settings:', error);
    },

    onSuccess: (saved) => {
      // saveBasicConfiguration answers 200 with an empty body, so `saved` is ''.
      // Only seed the cache when the server actually echoed the configuration back,
      // otherwise the page loses its data and renders empty.
      if (saved && typeof saved === 'object') {
        queryClient.setQueryData(['configuration.basic', companyId], saved);
      }
      queryClient.invalidateQueries({
        queryKey: ['configuration.basic', companyId],
      });
    },
  });
}
